import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Row, Col, Table, Button, Card, CardHeader, CardBody } from "reactstrap";
import { Link } from "react-router-dom";
import _ from "lodash";

import DefaultDataGrid from "modules/5_view_helpers/web/DefaultDataGrid";
import columns from "./columns";

// Helpers
import NotAuthorized from "modules/5_view_helpers/web/NotAuthorized";
import HasRole from "modules/5_view_helpers/HasRole";

// Actions
import { getDrawingOfficeDrawingTypes } from "../actions";

function mapStateToProps(state) {
  return {
    drawing_office_drawing_types: state.drawing_office_drawing_types,
  };
}

const DrawingOfficeDrawingTypesIndex = (props) => {
  useEffect(() => {
    props.getDrawingOfficeDrawingTypes();
  }, []);

  const { drawing_office_drawing_types } = props;

  const readRole = HasRole({ resource_type: "DrawingOffice::DrawingType", name: ["read", "moderator"] });
  const createRole = HasRole({ resource_type: "DrawingOffice::DrawingType", name: ["create", "moderator"] });
  const updateRole = HasRole({ resource_type: "DrawingOffice::DrawingType", name: ["update", "moderator"] });

  if (!readRole) {
    return <NotAuthorized />;
  } else {
    return (
      <Card>
        <CardHeader>
          <Row>
            <Col>
              <h3>Drawing types</h3>
            </Col>
          </Row>
        </CardHeader>

        <CardBody>
          {createRole && (
            <Row>
              <Col>
                <Link to={`/drawing_office/drawing_types/new`}>
                  <Button color="primary" size="md">
                    <i className="fa fa-plus"> Create New Drawing type</i>
                  </Button>
                </Link>
              </Col>
            </Row>
          )}

          <Row className="mt-2">
            <Col>
              <DefaultDataGrid columns={columns(updateRole)} data={drawing_office_drawing_types} />
            </Col>
          </Row>
        </CardBody>
      </Card>
    );
  }
};
export default connect(mapStateToProps, { getDrawingOfficeDrawingTypes })(DrawingOfficeDrawingTypesIndex);
